import dynamic from 'next/dynamic';
const FilterTable = dynamic(() => import('./FilterTable'));

export { FilterTable };
